import { changeLocale } from '@hudl/statsbomb-frontends-adapter';
import { useKitbagAuth } from '@statsbomb/kitbag-auth';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Navigate } from 'react-router-dom';
import { userLocaleAtom } from '@/atoms/queries/userConfigs';

const NavigateToUserLocale = () => {
  const settingsLocale = useAtomValue(userLocaleAtom);
  const { locale: intlLocale } = useIntl();

  const targetLocale = settingsLocale ?? intlLocale;

  useEffect(() => {
    changeLocale(targetLocale);
  }, [targetLocale]);

  return <Navigate to={`/${targetLocale}`} replace />;
};

export const RedirectToLocalised = () => {
  const { isLoading } = useKitbagAuth();
  return isLoading ? null : <NavigateToUserLocale />;
};
